import { useContext } from 'react';

import BreadcrumbContext from './BreadcrumbContext';

export default function useBreadcrumb(): IBreadcrumbContext {
  return useContext(BreadcrumbContext) as IBreadcrumbContext;
}
